import partners, { DEFAULT_CAMPAIGN } from '../Data/partners';
import getHashUrlParams from '../shared/dom/getHashUrlParams';
import getHostTld from '../shared/dom/getHostTld';
import buildDeepLinkSystemPayload, {
  BuildDeepLinkSystemPayloadOptions,
} from '../services/deepLinks/buildDeepLinkSystemPayload';
import { DEFAULT_LOCALE, matchLocale } from '../../translations/locales';
import { Redirect, RedirectLocation } from '../shared/types/Redirect';

const getRedirect = (
  { hash, hostname, origin, userLocale }: RedirectLocation,
  now: Date = new Date(),
): Redirect => {
  const urlParams = getHashUrlParams(hash);

  const { locale: requestedLocale, route, queryParams } = urlParams;

  const displayLocale = requestedLocale || userLocale || DEFAULT_LOCALE;

  const locale = matchLocale(displayLocale);

  const {
    campaign,
    fallbackUrl,
    name: partnerName,
  } = partners[queryParams.campaign] || partners[route] || partners[DEFAULT_CAMPAIGN];

  const options: BuildDeepLinkSystemPayloadOptions = {
    locale,
    now,
  };
  const payload = buildDeepLinkSystemPayload(queryParams, options);

  const tld = getHostTld(hostname);

  const redirect = {
    campaign: route === 'clickthrough' ? route : campaign,
    fallbackUrl,
    locale,
    now,
    origin,
    partnerName: route === 'clickthrough' ? queryParams.partner || partnerName : partnerName,
    payload,
    queryParams,
    tld,
  };

  return redirect;
};

export default getRedirect;
